/**
 * LA LISTA DE NEGOCIOS EN ORDEN ALFABETICO (NEGOCIOS-ORDEN-T1, Josse 16-sep via Ares #15542).
 *
 * DE DONDE SALE. La lista de #/negocios se pintaba en el orden en que llegaba del API
 * (GET /api/businesses/all no recibe orden), y con 33 negocios no se encontraba nada.
 *
 * LA REGLA: por nombre comercial, en espanol, sin distinguir mayusculas ni acentos
 * ("Ábaco" junto a "abaco"), con los numeros en orden natural ("Sede 2" antes que
 * "Sede 10"). Los que no tienen nombre van al final. No cambia el arreglo recibido.
 *
 * Sin DOM: lo prueba scripts/check-negocios-orden.mjs.
 */

const COMPARAR = new Intl.Collator('es', { sensitivity: 'base', numeric: true });

const nombreDe = (b) => {
  const n = b && (b.displayName ?? b.DisplayName ?? b.display_name);
  return typeof n === 'string' ? n.trim() : '';
};

/** Una copia de la lista ordenada por nombre comercial. */
export function ordenarNegocios(items) {
  const lista = Array.isArray(items) ? items.slice() : [];
  return lista
    .map((b, i) => ({ b, i, n: nombreDe(b) }))
    .sort((x, y) => {
      if (!x.n && !y.n) return x.i - y.i;
      if (!x.n) return 1;
      if (!y.n) return -1;
      return COMPARAR.compare(x.n, y.n) || x.i - y.i;
    })
    .map((x) => x.b);
}
